import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faCircleDot } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { BULLET } from '@utils/constants';

export const SelectResourceUI = ({
  onClick,
  cover,
  title,
  name,
  subText,
  selected,
}: {
  onClick: () => void;
  cover: React.ReactNode;
  title: string;
  name: string;
  subText?: string;
  selected: boolean;
}) => {
  return (
    <div
      className="group mx-2 flex cursor-pointer items-center gap-2 rounded-md px-2 py-2 hover:bg-neutral50 lt:mx-4"
      onClick={onClick}
      tabIndex={0}
    >
      <div className="relative h-12 w-12 flex-00auto">{cover}</div>
      <div className="flex flex-1 flex-col justify-center gap-1">
        <div className="line-clamp-1 font-title text-title-xxs font-medium text-neutral700">
          {title}
        </div>
        <div className="flex items-center text-base-s text-base500">
          <div className="line-clamp-1 ">{name}</div>
          {subText && (
            <div className="line-clamp-1 ">
              {BULLET}
              {subText}
            </div>
          )}
        </div>
      </div>

      <div className="h-5 w-5">
        {selected ? (
          <FontAwesomeIcon icon={faCircleDot} size="lg" className="text-base800" />
        ) : (
          <FontAwesomeIcon icon={faCircle} size="lg" className="text-base500" />
        )}
      </div>
    </div>
  );
};
